var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtRsaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#EFF8F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3645_3544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6283 66.8012L77.095 64.8811L55.9205 44.8267C55.3072 44.2667 54.6138 44 53.8671 44C52.2137 44 50.9336 45.2801 50.9336 46.9335C50.9336 47.5735 51.1203 48.1335 51.467 48.5869C51.5736 48.7202 51.6536 48.8803 51.707 48.9069L66.9611 69.7613L67.9478 84.7221H81.8685L77.6283 66.8012Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3078 76.9346H52.641C49.7609 76.9346 47.4141 74.5878 47.4141 71.7077C47.4141 68.8542 49.7342 66.5074 52.5877 66.4807V47.0664H55.2545V69.1476H52.641C51.2276 69.1476 50.0809 70.2943 50.0809 71.7077C50.0809 73.1211 51.2276 74.2678 52.641 74.2678H55.3078V76.9346Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0015 49.0146C55.0766 49.0146 55.9482 48.143 55.9482 47.0679C55.9482 45.9927 55.0766 45.1211 54.0015 45.1211C52.9263 45.1211 52.0547 45.9927 52.0547 47.0679C52.0547 48.143 52.9263 49.0146 54.0015 49.0146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.857 101.389H101.87V98.7223H104.857C105.177 98.7223 105.443 98.4556 105.443 98.1356V84.0015H103.897C103.443 84.0015 103.017 83.7615 102.777 83.3882L93.9228 69.4941C93.8428 69.3874 93.7095 69.3074 93.5761 69.3074H83.5223V98.7223H85.309V101.389H82.1889C81.4422 101.389 80.8555 100.802 80.8555 100.056V69.3074C80.8555 67.8407 82.0555 66.6406 83.5223 66.6406H93.5761C94.6429 66.6406 95.6029 67.174 96.1629 68.054L104.617 81.3347H106.777C107.524 81.3347 108.11 81.9214 108.11 82.6681V98.1356C108.11 99.949 106.643 101.389 104.857 101.389Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.896 81.3633H85.3613V84.0301H103.896V81.3633Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.777 86.0547H101.23V88.7215H106.777V86.0547Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1234 108.137C90.6698 108.137 87.043 104.511 87.043 100.057C87.043 95.6034 90.6698 91.9766 95.1234 91.9766C99.577 91.9766 103.204 95.6034 103.204 100.057C103.204 104.511 99.577 108.137 95.1234 108.137ZM95.1234 94.6434C92.1366 94.6434 89.7098 97.0702 89.7098 100.057C89.7098 103.044 92.1366 105.471 95.1234 105.471C98.1102 105.471 100.537 103.044 100.537 100.057C100.537 97.0702 98.1102 94.6434 95.1234 94.6434Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0667 108.161C54.6132 108.161 50.9863 104.534 50.9863 100.08C50.9863 95.6269 54.6132 92 59.0667 92C63.5203 92 67.1472 95.6269 67.1472 100.08C67.1472 104.534 63.5203 108.161 59.0667 108.161ZM59.0667 94.6401C56.0799 94.6401 53.6531 97.0669 53.6531 100.054C53.6531 103.041 56.0799 105.467 59.0667 105.467C62.0536 105.467 64.4804 103.041 64.4804 100.054C64.4804 97.0669 62.0536 94.6401 59.0667 94.6401Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8699 68.1055H93.2031V82.6929H95.8699V68.1055Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8145 101.39V98.7228H80.8552V85.3621H47.3602C46.9602 85.3621 46.6668 85.6555 46.6668 86.0288V98.0561C46.6668 98.4295 46.9868 98.7228 47.3602 98.7228H49.467V101.39H47.3602C45.4934 101.39 44 99.8962 44 98.0561V86.0288C44 84.1887 45.5201 82.6953 47.3602 82.6953H82.1887C82.9354 82.6953 83.5221 83.282 83.5221 84.0287V100.056C83.5221 100.803 82.9354 101.39 82.1887 101.39H65.8145Z",
    fill: "#09081A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3645_3544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.11,
    height: 64.1633,
    fill: "white",
    transform: "translate(44 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtRsaIcon);
export default __webpack_public_path__ + "static/media/FtRSA Icon.636cbb4e.svg";
export { ForwardRef as ReactComponent };